import { Col, Dropdown, Empty, Input } from "antd";
import {
  SearchOutlined,
  FilterOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ConversationStatus } from "../../../../constant";
import { ChatLeftSkeleton } from "./ChatSkeleton";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../../store/chats/slice";
import { getChatMembers } from "../ChatWindow/helper";
import ConvListItem from "./ConvListItem";
import CreateConversation from "./CreateConversation";

const Conversations = (props) => {
  const {
    chats,
    topics,
    loading,
    selectedChatId,
    newMessageCount,
    setWidgetOpen,
  } = props;

  const [filters, setFilters] = useState({
    status: ConversationStatus.OPEN,
    topic_id: null,
    searchTerm: "",
  });

  const dispatch = useDispatch();

  const topicsItems = useMemo(
    () =>
      [{ id: "all", name: "All Topic" }, ...topics]?.map((item) => ({
        key: item.id,
        label: item.name,
        onClick: () =>
          onChangeFilter({
            key: "topic_id",
            value: filters?.topic_id === item?.id ? null : item.id,
          }),
      })),
    [topics, filters],
  );

  const onChangeFilter = useCallback(
    ({ key, value }) => {
      setFilters({ ...filters, [key]: value });
    },
    [filters],
  );

  const filteredChats = useMemo(() => {
    if (!chats) return [];

    const search = filters?.searchTerm?.toLowerCase()?.trim();

    return chats
      .filter((chat) => {
        const matchTopic =
          filters?.topic_id === "all" ||
          !filters?.topic_id ||
          chat?.topic?.id === filters.topic_id;

        const matchStatus =
          //@ts-ignore
          filters?.status === "all" ||
          !filters?.status ||
          chat?.status === filters.status;

        const matchSearch =
          !search ||
          chat?.display_id?.toString()?.toLowerCase()?.includes(search) ||
          chat?.branch?.name?.toLowerCase()?.includes(search) ||
          `${chat?.customer?.first_name} ${chat?.customer?.last_name}`
            ?.toLowerCase()
            ?.includes(search);

        return matchTopic && matchStatus && matchSearch;
      })
      .map((c) => ({ ...c, users: getChatMembers(c) }))
      .sort((a, b) => {
        const dateA = new Date(
          a?.last_message?.sent_at || a?.created_at,
        ).getTime();
        const dateB = new Date(
          b?.last_message?.sent_at || b?.created_at,
        ).getTime();

        return dateB - dateA;
      });
  }, [chats, filters]);

  useEffect(() => {
    if (newMessageCount) {
      dispatch(
        setKeyValue({
          key: "newMessageCount",
          value: 0,
        }),
      );
    }
  }, [newMessageCount]);

  return (
    <Col xs={24} className="conversations-panel">
      <div className="panel-header">
        <div className="flex justify-space-between panel-title">
          <h3>Conversations</h3>
          <div>
            <Dropdown
              menu={{
                items: topicsItems,
                selectedKeys: [filters.topic_id],
              }}
              placement="bottomRight"
            >
              <FilterOutlined
                title="Filter By Topics"
                className="cursor-pointer"
                size={50}
              />
            </Dropdown>
            <CreateConversation topics={topics} chats={chats} />
            {!!setWidgetOpen && (
              <span className="down-icon" onClick={() => setWidgetOpen(false)}>
                <DownOutlined
                  title="Close Chat Widget"
                  className="cursor-pointer"
                  size={50}
                />
              </span>
            )}
          </div>
        </div>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search..."
          value={filters.searchTerm}
          //@ts-ignore
          onChange={(e) =>
            onChangeFilter({ key: "searchTerm", value: e.target.value })
          }
          allowClear
        />
        <div className="filters hide-scrollbar">
          {["all", ...Object.values(ConversationStatus)].map((status) => (
            <div
              key={status}
              className={`capitalize-text filter-chip ${
                filters?.status === status ? "active" : ""
              }`}
              onClick={() => onChangeFilter({ key: "status", value: status })}
            >
              {status}
            </div>
          ))}
        </div>
      </div>
      <div className="chat-container hide-scrollbar">
        {loading ? (
          <ChatLeftSkeleton />
        ) : filteredChats?.length ? (
          filteredChats.map((chat, i) => (
            <ConvListItem chat={chat} selectedChatId={selectedChatId} key={i} />
          ))
        ) : (
          <Empty
            description="No conversations found"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        )}
      </div>
    </Col>
  );
};

export default Conversations;
